import BaseService from "@/services/BaseService";
import * as URI from "../tradePlan/constant";

const action = {
  async getTradePlanListAction({ commit }, payload) {
    let url = URI.TRADE_PLAN_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setTradePlanList", response.data.data);
    return response.data.data;
  },
  storeTradePlan({ commit }, payload) {
    commit("setTradePlan", payload);
  },
  async saveTradePlanDataAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.TRADE_PLAN_ADD_URL,
      payload
    );
    return response.data.data;
  },
  async getTradePlanDetailAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_DETAIL_URL.replace("{tradePlanId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setTradePlanDetail", response.data.data);
    return response.data.data;
  },
  updateBudgetHeadGridData({ commit }, payload) {
    commit("setBudgetHeadGridData", payload);
  },
  async addTradePlanBugetHeadAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.TRADE_PLAN_ADD_BUDGET_HEAD_URL,
      payload
    );
    return response.data;
  },
  async listTradePlanBudgetHeadAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_LISTING_BUDGET_HEAD_URL.replace("{tradePlanNumber}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setBudgetHeadList", response.data.data);
    return response.data.data;
  },
  async getSalesDetailsAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_GET_SALES_DETAILS_URL.replace("{tradePlanHdrId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesDetails", response.data.data);
    return response.data.data;
  },
  async getSalesDeductionPlanAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_GET_SALES_DEDUCTION_PLAN_URL.replace("{tradePlanHdrId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesDeductionPlanList", response.data.data);
    return response.data.data;
  },
  async updateTradePlanBugetHeadAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.TRADE_PLAN_UPDATE_BUDGET_HEAD_URL,
      payload
    );
    return response.data;
  },
  async deleteBugetHeadAction({ commit }, payload) {
    let ids = payload.map((obj) => `budgetHeadIds=${obj}`).join("&");
    let url = URI.TRADE_PLAN_DELETE_BUDGET_HEAD_URL.replace("{payload}", ids);
    const response = await BaseService.getSchemePlanningClient().delete(url,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async listTradePlanDetailAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_LISTING_PLAN_DETAIL_HEAD_URL
    .replace("{tradePlanNumber}", payload.tradePlanNumber)
    .replace("{tradePlanBudgetHeadId}", payload.tradePlanBudgetHeadId)
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setPlanDetailList", response.data.data);
    return response.data.data;
  },
  async resetPlanDetailAction({ commit }, payload) {
    let url = URI.TRADE_PLAN_RESET_PLAN_DETAIL_URL
    .replace("{budgetHeadId}", payload)
    const response = await BaseService.getSchemePlanningClient().delete(url,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async listTradePlanNetSalesAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_LISTING_NET_SALES_HEAD_URL.replace("{tradePlanNumber}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setNetSalesList", response.data.data);
    return response.data.data;
  },
  async DeleteTradePlanAction({ commit }, payload) {
    const url = URI.TRADE_PLAN_DELETE_URL.replace("{tradePlanNumber}", payload);
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  storeBudgetHeadObjectAction({ commit }, payload) {
    commit("setStoreBudgetHeadObject", payload);
  },
  async savePlanDetailAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.TRADE_PLAN_SAVE_PLAN_DETAIL_URL,
      payload
    );
    return response.data;
  },
};
export default action;
